"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ddEnv = exports.ddService = void 0;
exports.ddService = process.env.DD_SERVICE;
exports.ddEnv = process.env.DD_ENV;
